export default __webpack_public_path__ + "static/media/Infi.bf9ade75.jpg";